// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const MEDIA_BASE_URL = '/api/v1/wechat/media';

/**
 * 上传临时素材到企业微信
 * @param file 要上传的文件
 * @param mediaType 媒体文件类型：image（图片）、voice（语音）、video（视频）、file（普通文件）
 * @param options 请求配置
 */
export async function uploadMedia(
  file: File,
  mediaType: 'image' | 'voice' | 'video' | 'file',
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('media', file);
  formData.append('media_type', mediaType);

  return request<OA.ApiResponse<OA.MediaUploadResult>>(`${MEDIA_BASE_URL}/upload`, {
    method: 'POST',
    data: formData,
    // 不设置 Content-Type，让浏览器自动设置 multipart/form-data
    requestType: 'form',
    ...(options || {}),
  });
}

